import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstants } from 'src/app/core/constants';
import { removeUtmParams } from 'src/app/core/utils';

@Component({
  selector: 'app-filter-chip',
  templateUrl: './filter-chip.component.html',
  styleUrls: ['./filter-chip.component.scss',],
})
export class FilterChipComponent {

  queryParams: any[] = [];
  excludeParams = ['page', 'sortBy', 'orderBy', 'city',];
  constructor(private _router: Router, private _activateRoute: ActivatedRoute) {
    this._activateRoute.queryParams.subscribe(params => {
      this.toChips(params);
    });
  }

  toChips(params: any) {
    this.queryParams = [];
    params  = removeUtmParams(params);    //to remove UTM params for google-ads
    Object.keys(params).forEach(key => {
      if (this.excludeParams.includes(key)) return;
      const selectedParam = params[key];
      if (!selectedParam || !selectedParam.length) return;
      selectedParam.split(',').forEach((data: string) => {
        this.queryParams.push({ key, data: data, });
      });
    });
  }

  removeFilter(param: any) {
    const newParams = { ...this._activateRoute.snapshot.queryParams, };
    const prevData = newParams[param.key]?.split(',');
    const pos = prevData.indexOf(param.data);
    prevData.splice(pos, AppConstants.ONE);

    if (!prevData || !prevData.length) delete newParams[param.key];
    else newParams[param.key] = prevData.toString();
    this.toChips(newParams);
    this._router.navigate([], { queryParams: newParams, });
  }

  clearAllFilters() {
    const newParams = { ...this._activateRoute.snapshot.queryParams, };
    Object.keys(newParams).forEach(key => {
      if (this.excludeParams.includes(key)) return;
      delete newParams[key];
    });
    this._router.navigate(['cars',], { queryParams: newParams, });
  }

}
